var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkbox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.625 14.25H9.375C12.5 14.25 13.75 13 13.75 9.875V6.125C13.75 3 12.5 1.75 9.375 1.75H5.625C2.5 1.75 1.25 3 1.25 6.125V9.875C1.25 13 2.5 14.25 5.625 14.25Z",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.84375 7.99922L6.6125 9.76797L10.1562 6.23047",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkboxChecked.370e8a24c0882eb6ee3018572892340e.svg";
export { ForwardRef as ReactComponent };